import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { ContextChipComponent, ContextChipData } from '../../../shared/context-chip/context-chip.component';

/**
 * Header row of the message detail screen: back button, conversation subject as
 * title, message id, and the context chips (insured person, building, case,
 * category) of the displayed message. Presentational only.
 */
@Component({
  selector: 'app-conversation-header',
  imports: [MatButtonModule, MatIcon, TranslatePipe, ContextChipComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './conversation-header.component.html',
  styleUrl: './conversation-header.component.scss'
})
export class ConversationHeaderComponent {
  readonly subject = input<string | undefined>(undefined);
  readonly messageId = input<number | undefined>(undefined);
  readonly chips = input<ContextChipData[]>([]);

  readonly back = output<void>();
}
